import PropTypes from 'prop-types';
import { Flyout } from '@celltrak/ui-components';

import { useAction } from '../../../Common/hooks';
import { hideFlyout } from '../../../Dashboard/actions';
import { setCurrentRejectedsDetails } from '../../actions';
import RejectedTabs from '../RejectedTabs';

import styles from './RejectedFlyout.module.scss';

const RejectedFlyout = ({ show }) => {
  const dispatchHideFlyout = useAction(hideFlyout);
  const dispatchClearDetailsData = useAction(setCurrentRejectedsDetails);

  const handleOnCloseFlyout = () => {
    dispatchHideFlyout();
    dispatchClearDetailsData();
  };

  return (
    <Flyout
      show={show}
      className={styles.visitFlyout}
      heading="Record Details"
      onCloseClick={() => handleOnCloseFlyout()}
    >
      <RejectedTabs />
    </Flyout>
  );
};

RejectedFlyout.propTypes = {
  show: PropTypes.bool,
};

RejectedFlyout.defaultProps = {
  show: '',
};

export default RejectedFlyout;
